module.exports = __webpack_public_path__ + "img/banner-tc4-m.4274d7df.jpg";